export default __webpack_public_path__ + "static/sticker-healthyish-86fff33c6a13effd94e1e16081fe7a01.svg";